const videoAudioTogglers = document.querySelectorAll('.js-video-audio-toggler');
const videoAudioTogglersArr = Array.prototype.slice.call(videoAudioTogglers);

const videoAudio = {
  initialize() {
    if (videoAudioTogglersArr.length) {
      this.createListeners();
    }
  },

  createListeners() {
    videoAudioTogglersArr.forEach((toggler) => {
      toggler.addEventListener('click', ({ currentTarget }) => {
        this.video = currentTarget.parentNode.querySelector('video');

        // Toggle the sound on/off
        this.video.muted = !this.video.muted;

        // Add class to mute button to show/hide the line
        currentTarget.classList.toggle('is-mute', this.video.muted);

        // trackEvent('Video sound toggle', this.video.muted ? 'muted' : 'unmuted');
      });
    });
  },
};

export default videoAudio;
